"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinNotificationType = void 0;
var SpinNotificationType;
(function (SpinNotificationType) {
    SpinNotificationType["NONE"] = "none";
    SpinNotificationType["SUCCESS"] = "usersettings.weconnect.spin.change.confirmation";
    SpinNotificationType["SYSTEM_ERROR"] = "usersettings.weconnect.spin.systemerror.feedback";
    SpinNotificationType["CURRENT_MATCHES_NEW_SPIN_ERROR"] = "usersettings.weconnect.spin.invalidpin.feedback";
    SpinNotificationType["CURRENT_SPIN_INCORRECT_ERROR"] = "usersettings.weconnect.spin.invalidcurrentpin.feedback";
    SpinNotificationType["CONSECUTIVE_NUMBERS_ERROR"] = "usersettings.weconnect.spin.consecutiveNumbers.feedback";
    SpinNotificationType["EQUAL_NUMBERS_ERROR"] = "usersettings.weconnect.spin.sameNumbers.feedback";
    SpinNotificationType["MISMATCHING_SPIN_ERROR"] = "usersettings.weconnect.spin.mismatch.feedback";
})(SpinNotificationType || (exports.SpinNotificationType = SpinNotificationType = {}));
//# sourceMappingURL=SpinNotificationType.js.map